import { socket, SocketEvent } from "../socket";

export const userLogin = (): void => {
  socket.emit(SocketEvent.Login);
};
